import { render } from "./CommonExpenses.vue?vue&type=template&id=e92ced34&scoped=true"
import script from "./CommonExpenses.vue?vue&type=script&lang=js"
export * from "./CommonExpenses.vue?vue&type=script&lang=js"

import "./CommonExpenses.vue?vue&type=style&index=0&id=e92ced34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e92ced34"

export default script